module.exports = __webpack_public_path__ + "static/our-capabilities-bg-1600eee899a8c6cbd083e78a95942203.png";